import { _priceUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

const deletePrice = createAsyncThunk('deletePrice', async (data: any) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const requestBody = {
    modality: data.modality,
    studyRegion: data.studyRegion,
    id: data.id
  };
  try {
    let url = `${_priceUrls.delete}`;
    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });
    return await response.json();
  } catch (error) {
    return error;
  }
});

export default deletePrice;
